import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Prompt } from 'react-router';
import { withRouter } from 'react-router-dom';
import { matchPathname } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';

import InterruptProcessModal from '../InterruptProcessModal/InterruptProcessModal';
import { checkMarketplaceCurrentUser } from '../../util/data';
import { isLocalhost, parse } from '../../util/urlHelpers';

const UnsavedChangesWrapper = ({ children, currentUser, history, match }) => {
    const [leavePageModalVisible, setLeavePageModalVisibility] = useState(false);
    const [routePathname, setRoutePathname] = useState(null);

    const currentUserDefined = currentUser && currentUser.id;

    const handleNavigateToLocation = () =>
        history.push({ pathname: routePathname || '/', isNavigationAllowed: true });

    useEffect(() => {
        function showAlert(e) {
            if (isLocalhost()) return;

            const showAlertOnPageLeave = match.params.type === 'draft';

            if (!showAlertOnPageLeave) {
                return;
            }

            e.preventDefault();
            e.returnValue = '';
            return '';
        }

        window.addEventListener('beforeunload', showAlert);
        window.addEventListener('unload', showAlert);

        return () => {
            window.removeEventListener('beforeunload', showAlert);
            window.removeEventListener('unload', showAlert);
        };
    }, []);

    return (
        <>
            <InterruptProcessModal
                id="EditListingUnsavedChangesWrapper.modal"
                isOpen={leavePageModalVisible}
                onClose={() => setLeavePageModalVisibility(false)}
                handleInterruption={handleNavigateToLocation}
            >
                <InterruptProcessModal.Icon />
                <InterruptProcessModal.Heading />
                <InterruptProcessModal.Description>
                    Bist Du sicher, dass Du abbrechen und ohne vollständiges Profil weiterfahren
                    möchtest?
                </InterruptProcessModal.Description>
                <InterruptProcessModal.Footer>
                    <InterruptProcessModal.Sidenote>
                        Deine bisherigen Eingaben werden gespeichert und Du kannst das Profil
                        jederzeit vervollständigen.
                    </InterruptProcessModal.Sidenote>
                    <InterruptProcessModal.Button />
                </InterruptProcessModal.Footer>
            </InterruptProcessModal>

            {currentUserDefined && (
                <Prompt
                    message={location => {
                        const { isNavigationAllowed, pathname, search } = location;
                        if (isNavigationAllowed) return true;

                        const { skipUnsavedChangesAlert } = parse(search);

                        if (skipUnsavedChangesAlert) return true;

                        const {
                            route: { name },
                        } = matchPathname(pathname, routeConfiguration())[0];

                        const {
                            params: { type },
                        } = matchPathname(history.location.pathname, routeConfiguration())[0];

                        const isEditListingPage =
                            name === 'EditListingPage' || name === 'EditListingPageExternal';
                        const pageLeavingOnChangesUnsaved =
                            !isEditListingPage && (type === 'draft' || type === 'new');

                        if (pageLeavingOnChangesUnsaved) {
                            setRoutePathname(pathname);
                            setLeavePageModalVisibility(true);
                            return false;
                        }
                    }}
                />
            )}
            {children}
        </>
    );
};

const mapStateToProps = state => ({
    currentUser: checkMarketplaceCurrentUser(state),
});

export default compose(withRouter, connect(mapStateToProps))(UnsavedChangesWrapper);
